import gql from 'graphql-tag';

// The app has no idea what its own username is: sign-in stores only `token`
// and `rsc` (src/store/modules/user.js), and `rsc` holds e_code and r_stage.
// One small round-trip on load is what makes the sidebar able to decide.
export const GET_ME = gql`
  query me {
    me {
      userLogin
    }
  }
`;
